import { AbstractControl, ValidationErrors } from '@angular/forms'

export const ALPHANUMERIC_REGEX = /^[a-z0-9]+$/i

/**
 * Custom validator which validates that the control's value is alphanumeric (i.e. only contains (English) letters and
 * numbers), if the control's value is not empty.
 */
export function ValidateAlphanumeric(control: AbstractControl): ValidationErrors | null {
  if (control.value && !ALPHANUMERIC_REGEX.test(control.value)) {
    return { notAlphanumeric: true }
  }

  return null
}
